import {SYS} from '@/config'
import store from '../store'

import afterSaleRoutes from './module/aftersale.js';  		// 工单管理
import assetRoutes from './module/asset.js'; 				// 资产管理
import staffRoutes from './module/staff.js'; 				// 人员管理
import customerRoutes from './module/customer.js'; 			// 客户管理
import productRoutes from './module/product.js'; 			// 产品管理
import financeRoutes from './module/finance.js'; 			// 财务管理
import analysisRoutes from './module/analysis.js';			// 数据分析
import systemRoutes from './module/system.js';				// 系统管理
import basicRoutes from './module/basic.js';				// 基础数据
import workflowRoutes from './module/workflow.js';			// 流程引擎
import customRoutes from './module/custom';					// 自定义配置

const routes = [
	{
		path: '',
		name: 'home',
		meta: {
			authFree: true
		},
		component: () => import('@/pages/home/index')
	}, {
		path: 'message',
		component: () => import('@/pages/system/message_list.vue')
	}, {
		path: 'aftersale',
		name: 'p_aftersale',
		component: {
			render: h => h('router-view')
		},
		children: [
			...afterSaleRoutes
		]
	}, {
		path: 'asset',
		name: 'p_fixed_asset',
		component: {
			render: h => h('router-view')
		},
		children: [
			...assetRoutes
		]
	}, {
		path: 'staff',
		name: 'p_staff',
		component: {
			render: h => h('router-view')
		},
		children: [
			...staffRoutes
		]
	}, {
		path: 'customer',
		name: 'p_customer',
		component: {
			render: h => h('router-view')
		},
		children: [
			...customerRoutes
		]
	}, {
		path: 'product',
		name: 'p_product',
		component: {
			render: h => h('router-view')
		},
		children: [
			...productRoutes
		]
	}, {
		path: 'finance',
		name: 'p_financial',
		component: {
			render: h => h('router-view')
		},
		children: [
			...financeRoutes
		]
	}, {
		path: 'analysis',
		name: 'p_data_analysis',
		component: {
			render: h => h('router-view')
		},
		children: [
			...analysisRoutes
		]
	}, {
		path: 'system',
		name: 'p_organization',
		component: {
			render: h => h('router-view')
		},
		children: [
			...systemRoutes
		]
	}, {
		path: 'basic',
		name: 'p_basic',
		component: {
			render: h => h('router-view')
		},
		children: [
			...basicRoutes
		]
	}, {
		path: 'workflow',
		name: 'p_workflow',
		component: {
			render: h => h('router-view')
		},
		children: [
			...workflowRoutes
		]
	}, {
		path: 'custom',
		name: 'p_custom',
		component: {
			render: h => h('router-view')
		},
		children: [
			...customRoutes
		]
	}
];

export default [{
	path: '/login',
	name: 'login',
	meta: {
		loginFree: true
	},
	props: route => route.query,
	component: () => import('@/pages/login/index'),
	beforeEnter: (to, from, next) => {
		if (store.state.session) {
			next('/');
		} else {
			next();
		}
	}
}, {
	path: '/',
	component: () => import('@/pages/index'),
	children: routes,
	beforeEnter: async (to, from, next) => {
		if (SYS == 'digital') {
			next('/digital');
		} else if (SYS == 'outlet_asset_digital') {
			next('/outlet_asset_digital');
		} else {
			next();
		}
	}
}, {
	path: '/window',
	props: {
		windowPage: true
	},
	component: () => import('@/pages/index'),
	children: routes,
	beforeEnter: async (to, from, next) => {
		if (SYS == 'digital') {
			next('/digital');
		} else if (SYS == 'outlet_asset_digital') {
			next('/outlet_asset_digital');
		} else {
			next();
		}
	}
}, {
	path: '/digital',
	component: () => import('@/pages/kanban/digital')
}, {
	path: '/outlet_asset_digital',
	component: () => import('@/pages/kanban/outlet_asset_digital.vue')
}, {
	path: '/print',
	component: () => import('@/pages/home/print')
}, {
	path: '/doc',
	meta: {
		loginFree: true
	},
	component: () => import('@/pages/doc/index')
}, {
	path: '*',
	redirect: '/'
}];